/**
 * Converts bytes to human-readable format
 * @param {number} bytes - The number of bytes to convert
 * @param {number} decimals - Number of decimal places (default: 1)
 * @returns {string} Formatted string (e.g., "1.2 KB", "2.3 MB")
 */
export const formatBytes = (bytes, decimals = 1) => {
  if (bytes === 0) return '0 B';
  if (bytes < 0) return 'Invalid';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
};
